export enum IResetPasswordActionTypes {
	RECOVER_USERNAME_FROM_EMAIL = '@@resetPassword/RECOVER_USERNAME_FROM_EMAIL',
	RECOVER_USERNAME_FROM_EMAIL_FAILED = '@@resetPassword/RECOVER_USERNAME_FROM_EMAIL_FAILED',
	RECOVER_USERNAME_FROM_EMAIL_SUCCEED = '@@resetPassword/RECOVER_USERNAME_FROM_EMAIL_SUCCEED',
	RECOVERED_MULTIPLE_USERNAME = '@@resetPassword/RECOVERED_MULTIPLE_USERNAME',
	RECOVERED_SINGLE_USERNAME = '@@resetPassword/RECOVERED_SINGLE_USERNAME',
	SEND_RESET_PASSWORD_EMAIL = '@@resetPassword/SEND_RESET_PASSWORD_EMAIL',
	SEND_RESET_PASSWORD_EMAIL_FAILED = '@@resetPassword/SEND_RESET_PASSWORD_EMAIL_FAILED',
	SEND_RESET_PASSWORD_EMAIL_SUCCEED = '@@resetPassword/SEND_RESET_PASSWORD_EMAIL_SUCCEED',
}

export interface IResetPasswordState {
	readonly email: string;
	readonly recoveredUsernameIsError: string;
	readonly recoveredUsernameIsMultiple: boolean;
	readonly recoveredUsernameIsSuceed: boolean;
	readonly resetIsError: string;
	readonly resetIsSucceed: boolean;
	readonly username: string;
}
